function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.75 3A2.25 2.25 0 0121 5.25v16.5A2.25 2.25 0 0118.75 24H2.25A2.25 2.25 0 010 21.75V5.25A2.25 2.25 0 012.25 3H4.5V.562C4.5.254 4.753 0 5.063 0h1.875c.309 0 .562.253.562.563V3h6V.562c0-.309.253-.562.563-.562h1.874c.31 0 .563.253.563.563V3h2.25zm-.281 18.75a.282.282 0 00.281-.281V7.5H2.25v13.969c0 .154.127.281.281.281H18.47z"
});

var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 21 24"
  }, props), _ref);
};

export default SvgCalendarIcon;